// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.nhraTrackLocator = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}
		

		// Default settings are set here.
		var settings = $.extend({
			wrapper: '.track-locator',
			selector: '.track-locator__sector',
			activeClass: 'track-locator__sector--active'
		}, options);

		var $document = $(document);

		var $divisionBtn = $('.division-btn');

		// These are all the methods available for the plugin.
		var methods = {},
		$trackContainer,
		$selector = $(settings.selector),
		timer,
		$desktop;

		methods.smoothScroll = function (event) {

			var hash = false;
			// Make sure this.hash has a value before overriding default behavior
			if (event.currentTarget.hash && event.currentTarget.hash !== "") {
				hash = event.currentTarget.hash;
			} else if (event.currentTarget.href.animVal && event.currentTarget.href.animVal !== "") {
				// Store hash
				hash = event.currentTarget.href.animVal;
			}

			if (hash) {
				// Prevent default anchor click behavior
				event.preventDefault();
				
				var menuOffset = $('header').height();
				var hashTarget = $(hash).offset().top;
				var scrollTopVal = hashTarget - menuOffset;

				// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
				$('html, body').animate({
					scrollTop: scrollTopVal
				}, 800, 'swing', function () {
					$('header').offset({top:0});
					$("#t-tip-container").tooltip("close");
					// Add hash (#) to URL when done scrolling (default click behavior)
					//window.location.hash = hash;
				});
			} // End if
		
	}

	methods.tooltipInit = function (event) {
		$( '.division-btn' ).tooltip({
			disabled: true,
			show: { effect: "blind", duration: 200 },
			track: false,
			tooltipClass: "division-tooltip",
			items: "a.division-btn",
			close: function( event, ui ) {
				return;
				event.stopImmediatePropagation();
			}
    });
	}

	methods.getTrackList = function (event) {
		var x = $('.' + event.currentTarget.id + '.track-name');
		var divTitle = event.currentTarget.getAttribute('aria-label');
		var html = '<div>' + divTitle + '</div>';
		html = html + '<ul class="t-tip">';

		x.each(function(){
			var x = 1;

			var track = $(this).find(":not(a)").addBack().contents().filter(function() { return this.nodeType == 3;}).text();

			var curEl = track;

			var name = curEl

			name = name.replace(/[\s,\-\/\.\(\)]+/g, '');

			name = name.toLowerCase();

			if (!name) {
				return;
			}

			html = html + '<li><a href="#' + name + '" id="' + name + '-link" class="track-link">' + curEl + '</a></li>'
		});

		html = html + '</ul>';

		var temp = html;

		html = '';

		return temp;
	}

	methods.keyUp = function (event) {
		if (27 == event.keyCode){
			if($divisionBtn.tooltip( "instance" )) {
				$divisionBtn.tooltip('disable').tooltip('close');
			}
		}
	}

	methods.tooltipClose = function (event) {
		$divisionBtn.tooltip('disable').tooltip('close');
	}

	methods.setCurrentSettings = function($context) {
		var currentSettings = $context.data();

		if (!$.isEmptyObject(currentSettings)) {	
			$context.data($.extend({}, settings, currentSettings));
		} else {
			$context.data(settings);
		}

			// Initialize item.
			$context.data('initialized', true);
	}

	// On load function
	methods.initContext = function($context) {
		methods.setCurrentSettings($context);

		// Window onload event required as svg needs to be loaded before the code is run.
		window.onload = function () {
			methods.bind($context);
		}
	}

	methods.bind = function ($context) {
		// Get the SVG content.
		$trackContainer = $context.find('#nhraTrackLocator').contents();

		$divisionBtn.tooltip(function(event){
			methods.tooltipInit(event);
		});

		$document.click(function(event) {
			methods.tooltipClose(event);
		});

		$('.division-btn').on('mouseenter', function(event){
			$('.division-btn').tooltip('disable');
			var str = methods.getTrackList(event);
			var thisTarget = event.currentTarget;

			$(this).tooltip({
				items: "#" + event.currentTarget.id,
				content: str,
				position: {
					my: "left top - 100",
					at: "left bottom",
					of: '#' + event.currentTarget.id,
					collision: "flip none"
				},
			})
			.tooltip('open')
			.mouseout(function(){
				$(this).tooltip('disable')
			});

			if( 0 == $('[role="tooltip"]').offset().top) {
				var newTop =  $(this).position().top + event.pageY;
				var newLeft = $(this).position().left + event.pageX;
				$('[role="tooltip"]').css({left: newLeft, top: newTop});
			}

			// Add smooth scrolling to all links
			$('a.division-btn, a.top-btn, a.track-link').on('click', function (event) {
				event.preventDefault();
				methods.smoothScroll(event);
			});

			$('.ui-tooltip-content').on('mouseleave focusout blur', function(event){ 
				$('.division-btn').tooltip('disable').tooltip('close');
			});
			
		});

		$('.division-btn').on('mouseout focusout', function(event) {
			event.stopImmediatePropagation();
		});

		$(document).click(function(e) {
			$('.division-btn').tooltip('disable').tooltip('close');
		});

		$document.keyup(function(event) {
			methods.keyUp(event);
		});
	}

	// Filter each function.
	methods.filterEach = function() {
		return !$(this).data("initialized");
	}

	// Methods to run inside loop.
	return this.filter(methods.filterEach).each(function() {
		var $this = $(this);

		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($this);
	});

	};
}(jQuery));
